import axios from 'axios'
import store from '../store'
import interceptorsSetup from './interceptors'

  const serviceBO = axios.create({
    baseURL: process.env.VUE_APP_BASE_BO,
    timeout: process.env.VUE_APP_API_TIMEOUT
  })
  interceptorsSetup(serviceBO)
  serviceBO.interceptors.request.use(
    config => {
      if (store.getters["auth/token"]) {
        config.headers["Authorization"] = "Bearer " + store.getters["auth/token"].accessToken;
      }
      return config
    })

  export default serviceBO
